export default "__VITE_ASSET__DGjNtIZX__"